<template>
    <div class="majors_home">
        <HeadImg :msg="titleName" :url="imgMajors"></HeadImg>
        <div class="shilineBox">
            <div class="rLine"></div>
            <div class="cLine"></div>
        </div>

        <div class="majors1">
            <div class="section_title wow bounceInLeft">
                <p class="section_cn">热门专业</p>
                <p class="section_en">POPULAR MAJORS</p>
            </div>
            <div class="m1_cont">
                <div class="m1_item" @click="majorDetail(2)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 518.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">服装设计</div>
                        <div class="m1_item_pbox">
                            <p>FASHION</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>
                <div class="m1_item" @click="majorDetail(15)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 519.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">景观设计</div>
                        <div class="m1_item_pbox">
                            <p>LANDSCAPE</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>
                <div class="m1_item" @click="majorDetail(19)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 512.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">工业设计</div>
                        <div class="m1_item_pbox">
                            <p>INDUSTRIAL</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>
                <div class="m1_item" @click="majorDetail(8)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 513.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">插画设计</div>
                        <div class="m1_item_pbox">
                            <p>ILLUSTRATION</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>

                <div class="m1_item" @click="majorDetail(4)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 514.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">动画设计</div>
                        <div class="m1_item_pbox">
                            <p>ANIMATION</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>
                <div class="m1_item" @click="majorDetail(13)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 515.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">建筑设计</div>
                        <div class="m1_item_pbox">
                            <p>ARCHITECTURE</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>
                <div class="m1_item" @click="majorDetail(20)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 516.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">交互设计</div>
                        <div class="m1_item_pbox">
                            <p>INTERACTION</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>
                <div class="m1_item" @click="majorDetail(16)">
                    <div class="m1_item_top">
                        <img src="../img/热门专业切图/Group 517.png" alt="">
                    </div>
                    <div class="m1_item_bottom">
                        <div class="m1_item_h">室内设计</div>
                        <div class="m1_item_pbox">
                            <p>INTERIOR</p>
                            <p>DESIGN</p>
                        </div>
                        <div class="m1_item_arrow"></div>
                    </div>
                </div>

            </div>
        </div>

        <div class="majors2" id="majors2">
            <div class="section_title wow bounceInLeft">
                <p class="section_cn">专业分类</p>
                <p class="section_en">MAJOR CATEGORIES</p>
            </div>
            <div class="m2_cont">
                <div class="m2_nav_box">
                    <div class="m2_nav_li" v-for="(item, index) in germList" @click="scrollGerm(index)">
                        <p class="cn">{{ item.cname }}</p>
                        <p class="en">{{ item.ename }}</p>
                    </div>

                </div>
                <div class="m2_main">
                    <div class="m2_item" v-for="(item, index) in germList">
                        <div class="m2_item_left">
                            <p class="m2_item_p1">{{ item.cname }}</p>
                            <div>
                                <P class="m2_item_p2">{{ item.ename }}</P>
                                <div class="m2_item_kuang">
                                    <div class="m2_item_neiKuang"></div>
                                </div>
                            </div>
                        </div>
                        <div class="m2_item_right">
                            <div class="m2_item_li" v-for="(item2, index2) in item.get_major" @click="majorDetail(item2.id)">
                                <img :src="'https://public.rossoarts.com/static/uploads/' + item2.image" alt="">

                                <p class="m2_item_li_p1">{{ item2.cname }}</p>
                                <p class="m2_item_li_p2">{{ item2.ename | toUpper}}</p>
                            </div>
                        </div>
                    </div>

                    <div class="m2_fix" id="m2_fix">
                        <div class="m2_fix_item" v-for="(item, index) in germList" @click="scrollGerm(index)" @mouseenter="visGerm(index)" @mouseleave="hidGerm(index)">
                            <p class="m2_fix_item_p wlhpp">{{ item.cname }}</p>
                            <div class="m2_fix_item_circle"></div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <div class="majors3" id="majors3">
            <div class="section_title wow bounceInLeft">
                <p class="section_cn">专业资讯</p>
                <p class="section_en">MAJOR NEWS</p>
            </div>
            <div class="m3_cont">
                <div class="swiper mySwiperM1">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in artsNews">
                            <div v-for="(item2, index2) in item" class="m3_item" @click="artNewJop(item2.id)">
                                <img :src="'https://public.rossoarts.com/static/uploads/article/' + item2.list_img" alt="">
                                <div class="m3_item_p1">{{ item2.title }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-pagination"></div>
                </div>
                <div class="m3_more_box" @click="jopNews">
                    <img src="../img/热门专业切图/Group 521.png" alt="">
                    <p>了解更多</p>
                </div>
            </div>
        </div>

        <!-- 最外层div -->
    </div>
</template>

<script>
import HeadImg from '@/components/HeadImg.vue'
import imgMajors from '@/img/热门专业切图/Rectangle 918.png'
import "@/assets/css/majors.css"
import axios from 'axios'
import Swiper from 'swiper/bundle'
import 'swiper/css';
import "swiper/css/effect-flip";
import 'swiper/css/pagination';
import 'swiper/css/navigation';
export default {
    components: {
        HeadImg
    },
    data() {
        return {
            imgMajors,
            titleName: {
                cname: "艺术专业",
                ename: "ART MAJOR"
            },
            germList: [],
            artsNews: [],
            flag:true,
        }
    },
    created() {
        this.getMajor()
        this.getArtsNew()
    },
    filters:{
        toUpper(val){
            return val.toUpperCase();
        }
    },
    methods: {
        jopNews(){
            this.$router.push("/news.html")
        },
        majorDetail(val){
            // console.log(val);
            // window.open(`https://public.rossoarts.com/majors/${val}.html`,"_blank")
         
            this.$router.push(`/majors/${val}.html`)
        },
        hidGerm(val){
            // console.log(val);
            var m2_fix_item_p = document.getElementsByClassName("m2_fix_item_p")
            
            // console.log(m2_fix_item_p[val].style.color);
            if(m2_fix_item_p[val].style.color == "rgb(194, 194, 194)"){
                m2_fix_item_p[val].style.visibility = "hidden"
                // console.log("进");
            }
           
        },
        visGerm(val){
            // console.log(val);
            var m2_fix_item_p = document.getElementsByClassName("m2_fix_item_p")
            
            if(m2_fix_item_p[val].style.color == "#FB6333"){
                this.flag = false
            }
                m2_fix_item_p[val].style.visibility = "visible"
            
            
        },
        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
      
        artNewJop(val) {
            // window.open(`https://public.rossoarts.com/news/${val}.html`, '_blank')
            this.$router.push(`/news/${val}.html`)
        },
        getArtsNew() {
            axios.get("https://public.rossoarts.com/api/v1/getArtsNews?category=1&limit=30&page=1").then((data) => {
                // console.log(data.data.data.data, "资讯");
                this.artsNews = this.arrGroup(data.data.data.data, 6)
                // console.log(this.artsNews);
                this.$nextTick(() => {
                    this.swiperM1()
                })
            })
        },
        getMajor() {
            axios.get("https://public.rossoarts.com/api/v1/getSubject").then((data) => {
                // console.log(data.data.data);

                this.germList = data.data.data.sort(function (a, b) {
                    return a.sort - b.sort
                })
                // console.log(this.germList);
            })
        },
        scrollGerm(val) {
            var m2_item = document.getElementsByClassName("m2_item")
            var m2_item_left = document.getElementsByClassName("m2_item_left")
            m2_item[val].scrollIntoView({
                block: 'end',
                behavior: 'smooth',

            })
        },
        swiperM1() {
            var swiper = new Swiper(".mySwiperM1", {
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
            });
        },
        windowScroll() {

            var majors2 = document.getElementById("majors2")
            var majors3 = document.getElementById("majors3")
            var m2_fix = document.getElementById("m2_fix")
 
            var st = document.documentElement.scrollTop;
            var h = window.innerHeight;
            var os = majors2.offsetTop;
            var os2 = majors3.offsetTop
            // console.log(st, h, os, "st,h,os");
            if (st > os) {
                if (m2_fix) {
                    m2_fix.style.display = "block";
                }
                if (st + 200 > os2) {
                    m2_fix.style.display = "none";
                }
            }else{
                m2_fix.style.display = "none";
            }
            var m2_item = document.getElementsByClassName("m2_item")
            var m2_fix_item = document.getElementsByClassName("m2_fix_item")
            var m2_fix_item_circle = document.getElementsByClassName("m2_fix_item_circle")
            var m2_fix_item_p = document.getElementsByClassName("m2_fix_item_p")
            for (var i = 0; i < m2_item.length; i++) {
                var ositem = m2_item[i].offsetTop;

                if (ositem <= st + h / 2) {

                    for (var j = 0; j < m2_fix_item.length; j++) {
                        m2_fix_item_circle[j].style.backgroundColor = "#C2C2C2";
                        m2_fix_item_p[j].style.visibility = "hidden"
                        m2_fix_item_p[j].style.color = "#c2c2c2"
                    }
                    m2_fix_item_circle[i].style.background = "#FB6333";
                    m2_fix_item_p[i].style.visibility = "visible"
                    m2_fix_item_p[i].style.color = "#FB6333"
                }
            }

            // }, 1)
        },
    },
    mounted() {
        window.addEventListener("scroll", this.windowScroll, true);
    },
    destroyed() {
        window.removeEventListener("scroll", this.windowScroll, true);
    },
}
</script>